/* eslint-disable @typescript-eslint/naming-convention */
import React from "react";
import { Login } from "react-admin";

import CodeFormForm from "../../components/CodeForm/CodeForm";
import EmailVerifyForm from "../../components/EmailVerifyForm/EmailVerifyForm";
import MfaForm from "../../components/MfaForm/MfaForm";
import MfaQrCode from "../../components/MfaQrCode";
import PasswordForm from "../../components/PasswordForm/PasswordForm";

import { AUTH_FLOW } from "../../store/models/auth";
import useAuthMutations from "../../store/mutations/useAuthMutations";

import "./LoginView.css";

const LoginView: React.FC = () => {
  const { authState } = useAuthMutations();
  const { authFlow, email, password_digest, mfaSetupData } = authState;

  const renderForm = () => {
    switch (authFlow) {
      case AUTH_FLOW.CHECK_EMAIL:
        return <EmailVerifyForm />;

      case AUTH_FLOW.WITH_INVITATION_CODE:
        return <CodeFormForm email={`${email}`} />;

      case AUTH_FLOW.BASIC:
        return <PasswordForm email={`${email}`} />;

      case AUTH_FLOW.FIRST_SIGN_IN:
        return <PasswordForm email={`${email}`} isFirstSignIn />;

      case AUTH_FLOW.MFA_SETUP:
      case AUTH_FLOW.MFA_SETUP_COMPLETED:
      case AUTH_FLOW.MFA_CHECK:
        return (
          <MfaForm
            email={`${email}`}
            password_digest={`${password_digest}`}
            isMfaSetup={authFlow === AUTH_FLOW.MFA_SETUP}
            isMfaCheck={authFlow === AUTH_FLOW.MFA_CHECK}
            isMfaCompleted={authFlow === AUTH_FLOW.MFA_SETUP_COMPLETED}
          />
        );

      default:
        return null;
    }
  };

  const renderQrCode = () => {
    if (authFlow === AUTH_FLOW.MFA_SETUP || authFlow === AUTH_FLOW.MFA_SETUP_COMPLETED) {
      return mfaSetupData?.qrImage && mfaSetupData?.code ? (
        <MfaQrCode qrImage={mfaSetupData.qrImage} code={mfaSetupData.code} />
      ) : null;
    }
    return null;
  };

  return (
    <div className="v-login">
      <Login className="v-login__container">
        {renderQrCode()}
        {renderForm()}
      </Login>
    </div>
  );
};

export default LoginView;
